import { render, staticRenderFns } from "./HiddenItemButton.vue?vue&type=template&id=0a0d30ab&scoped=true"
import script from "./HiddenItemButton.vue?vue&type=script&lang=js"
export * from "./HiddenItemButton.vue?vue&type=script&lang=js"
import style0 from "./HiddenItemButton.vue?vue&type=style&index=0&id=0a0d30ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0d30ab",
  null
  
)

export default component.exports